module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('iframe', {
    staticStyle: {
      "width": "100%",
      "height": "1100px"
    },
    attrs: {
      "id": "myIframe",
      "src": "/Service/lhmj/ruralPlaningResearch2",
      "frameborder": "0"
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ed7b9e22"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/wjdc/index.vue
// module id = 914
// module chunks = 2